import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import CloudIcon from '@material-ui/icons/Cloud';

export default createFrontendPlugin({
  pluginId: 'galileo-s3-explorer',
  extensions: [
    PageBlueprint.make({
      name: 'main',
      params: {
        path: '/s3-explorer',
        title: 'S3 Explorer',
        icon: <CloudIcon />,
        loader: async () => {
          const module = await import('./components/S3ExplorerPage');
          return import('react').then(React =>
            React.createElement(module.S3ExplorerPage),
          );
        },
      },
    }),
  ],
});
